import WarningIcon from '@material-ui/icons/Warning';

class ImageResource {
  _cache = {};

  preload(src) {
    if (this._cache[src] === undefined) {
      this._cache[src] = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          this._cache[src] = true;
          resolve(this._cache[src]);
        };
        img.onerror = () => {
          this._cache[src] = false;
          reject();
        };
        img.src = src;
      });
    }
    if (this._cache[src] instanceof Promise) {
      throw this._cache[src];
    }
    return this._cache[src];
  }
}
const resource = new ImageResource();

const SuspenseImage = ({src, alt, errorComponent, ...rest}) => {
  if (!src) return null;
  const loaded = resource.preload(src);
  return loaded ?
    <img src={src} alt={alt} {...rest}/> :
    errorComponent || <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      alignItems: 'center',
      lineHeight: '1.5rem',
      color: 'rgba(0,0,0,.25)',
    }}><WarningIcon/>image error.</div>;
};

export default SuspenseImage;